// @flow

import classnames from "classnames";
import type { ChildrenArray } from "react";
import React from "react";

import { BruIcon, ContinueLink } from "@/components";
import type { Icon } from "@/components/BruIcon/BruIcon";

type BrandBlockProps = {
    header?: {
        image: string,
    },
    link: Link,
    children: ChildrenArray<React$Node>,
    headerText?: {
        title: string,
        subTitle: string,
        icon: Icon,
        color: string,
    },
    image?: React$Node,
    imageFill?: boolean,
    customIcon?: React$Node,
};

const BrandBlock = (
    {
        header,
        children,
        link,
        headerText,
        image,
        imageFill,
        customIcon
    }: BrandBlockProps,
): React$Element<"div"> => (
    <div className="brand-block">
        <a href={link.path} target={link.target}>
            <header
                className={
                    imageFill
                        ? "d-flex w-100 pt-xl-6"
                        : headerText
                            ? "brand-block-header-no-image"
                            : "brand-block-header"
                }
            >
                {header && (
                    <img
                        src={header.image}
                        alt={"Brand logo"}
                        className={classnames(
                            "image",
                            imageFill && "mw-100 w-100",
                        )}
                    />
                )}
                {image && image}
                {headerText && (
                    <div className={`text-${headerText.color}`}>
                        <BruIcon
                            size="lg"
                            icon={headerText.icon}
                        />
                        <div>
                            <h2 className="mb-0 pb-0 text-uppercase">
                                {headerText.title}
                            </h2>
                            <h2 className="opacity-50">
                                {headerText.subTitle}
                            </h2>
                        </div>
                    </div>
                )}
            </header>
        </a>

        <div className="brand-block-content pt-4 mt-md-2 px-sm-4">
            <div className="text-muted mb-3 mb-lg-4">{children}</div>

            <ContinueLink
                to={link.path}
                target={link.target}
                variant="dark"
                icon={customIcon ? customIcon : undefined}
            >
                {link.text}
            </ContinueLink>
        </div>
    </div>
);

export default BrandBlock;
